export default __webpack_public_path__ + "static/media/IMG_0295.f0bc163a.JPG";